import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";

export class RpReportSortingDto extends DtoDetail {

    public name : string;
    public description : string;
    public sortingJson : string;
    public sourceObjectTypeDtoId : number;
    public sourceObjectTypeDtoName : string;
    public sourceObjectTypeDtoImage : string;
    public sourceObjectTypeDtoColor : string;
}
